<template>
  <div class="p-4">
    <button @click="$router.push('/ecommerce/supply/goods/new')" class="float-right border-2 border-blue-500 text-blue-500 font-bold py-2 px-4 rounded">
      New Goods
    </button>
    <el-table
      :data="supplies.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))"
      :default-sort = "{prop: 'id', order: 'ascending'}"
      style="width: 100%">
      <el-table-column
        prop="code"
        label="Code"
        sortable>
      </el-table-column>
      <el-table-column
        label="Outlet"
        sortable>
        <template slot-scope="scope">{{scope.row.outlet.name}}</template>
      </el-table-column>
      <el-table-column
        label="Supplier"
        sortable>
        <template slot-scope="scope">{{scope.row.supplier.name}}</template>
      </el-table-column>
      <el-table-column
        label="Quantity"
        sortable>
        <template slot-scope="scope">{{scope.row.goods.length}}</template>
      </el-table-column>
      <el-table-column align="right" fixed="right">
        <template slot="header" slot-scope="scope">
          <el-input
            v-model="search"
            size="mini"
            placeholder="Type to search"/>
        </template>
        <template slot-scope="scope">
          <el-button @click="viewSupply(scope.row.id)" type="text" size="small">
            <i class="text-xl text-gray-500 el-icon-view mr-1"></i>
          </el-button>
          <el-button @click="editSupply(scope.row.id)" type="text" size="small">
            <i class="text-xl el-icon-edit-outline mr-4"></i>
          </el-button>
          <el-button @click="deleteSupply(scope.row.id)" type="text" size="small">
            <i class="text-xl text-red-500 el-icon-delete-solid"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>

import { flatMap } from 'lodash';

export default {
  name: 'Supplies',
  data() {
    return {
      search: '',
    };
  },
  computed: {
    supplies() {
      return flatMap(this.$store.state.InventoryModule.Supplies.supplies);
    },
  },
  mounted() {
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
  },
  methods: {
    viewSupply(id) {
      this.$router.push(`/ecommerce/supply/goods/${id}/details`);
    },
    editSupply(id) {
      this.$router.push(`/ecommerce/supply/goods/${id}/edit`);
    },
    async deleteSupply(supplyId) {
      this.$confirm('Are you sure you want to delete this supply?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning',
      }).then(async () => {
        try {
          await this.$store.dispatch('InventoryModule/Supplies/deleteSupply', { supplyId });
          this.$notify.success({
            title: 'Success',
            message: 'Supply has been deleted.',
          });
        } catch (e) {
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong please try again.',
          });
        }
      });
    },
  },
};
</script>

<style scoped>

</style>
